
export const encodeQueryData = (params) => {
  if (params) {
    return Object.keys(params).filter(key => params[key] !== undefined).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join("&");
  }
  return ""
};
